import {Pipe, PipeTransform} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {MsalService} from "@azure/msal-angular";

@Pipe({
  name: 'authImage'
})
export class AuthImagePipe implements PipeTransform {

  constructor(
    private http: HttpClient,
    private msalAuthService: MsalService,// our service that provides us with the authorization token
  ) {}

  async transform(src: string): Promise<string> {
    const token = this.msalAuthService.instance.getActiveAccount().idToken;
    const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
    try {
      const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).toPromise();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(imageBlob);
      });
    } catch {
      return 'assets/images/logomark.svg';
    }
  }

}
